import { notification } from 'antd'
import apiClient from '../index'

export const getEmailTemplate = async (value) => {
  try {
    return await apiClient.get(`email-template/${value}`)
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}

export const getAllEmailTemplate = async ({ skip, limit, search, templateType }) => {
  try {
    return await apiClient.get('email-template', {
      params: { skip, limit, search, templateType },
    })
  } catch (error) {
    notification.error({
      message: error?.message,
    })
  }
  return null
}
export const getTemplateVariables = async (uniqueValue) => {
  try {
    return await apiClient.get(`email-template/variables/${uniqueValue}`)
  } catch (error) {
    notification.error({
      message: error?.response?.data?.message || error?.message,
    })
  }
  return null
}
export const createTemplate = (data) => apiClient.post('email-template', data)
export const getEmailTemplateById = (id) => apiClient.get(`email-template/data/${id}`)
export const updateEmailTemplate = (id, data) => apiClient.patch(`email-template/${id}`, data)
